// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"1d0038d2","450":"67da2dc5"}[chunkId] + ".chunk.css";
};